import { IShowError } from "shared/modal/error-modal/error-modal.types";

/**
 * Show an error when the user's browser does not allow them to view attachments.
 * @param showError Show error method.
 */
export default function showBlockedAttachmentsError(showError: IShowError) {
    return () => showError("Attachments Blocked", "You must enable pop-ups to view attachments.");
}
